import React, { FC } from 'react';

const style = require('./AddressDisplay.less');

interface AddressDisplayProps {
	address: any;
	hideStreetAddress?: boolean;
	hideCity?: boolean;
	hideRegion?: boolean;
	hidePostcode?: boolean;
	hideCountry?: boolean;
	style?: React.CSSProperties;
	className?: string;
	prefix?: React.ReactNode;
}

export const AddressDisplay: FC<AddressDisplayProps> = ({
	address,
	hideStreetAddress,
	hideCity,
	hideRegion,
	hidePostcode,
	hideCountry,
	prefix,
	...props
}) => {
	if (!address) {
		return null;
	}

	return (
		<div className={`addressDisplay ${props.className}`} style={props.style}>
			{prefix}
			{!hideStreetAddress && (
				<>
					{address.streetAddress2Opt && <div>{address.streetAddress2Opt}</div>}
					<div>{address.streetAddress1}</div>
				</>
			)}
			<div>
				{!hideCity && <span>{address.city}</span>}
				{!hideRegion && (
					<span>
						{address.city && ','} {address.region}
					</span>
				)}
				{!hidePostcode && <span> {address.postcode}</span>}
			</div>
			{!hideCountry && <div>{address.country}</div>}
		</div>
	);
};
